"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocketScope = exports.SocketEntity = exports.SocketPlace = void 0;
var SocketPlace;
(function (SocketPlace) {
    SocketPlace["USER_PAGE"] = "user-page";
})(SocketPlace || (exports.SocketPlace = SocketPlace = {}));
var SocketEntity;
(function (SocketEntity) {
    SocketEntity["USER_STATUS"] = "user-status";
    SocketEntity["POST"] = "post";
    SocketEntity["AUDIO"] = "audio";
})(SocketEntity || (exports.SocketEntity = SocketEntity = {}));
var SocketScope;
(function (SocketScope) {
    SocketScope["ENTITY"] = "entity";
    SocketScope["USER"] = "user";
})(SocketScope || (exports.SocketScope = SocketScope = {}));
